export default {
  title: 'Registro de Errores',
  cleanupOld: 'Limpiar Antiguos',
  refresh: 'Actualizar',
  selected: 'seleccionados',
  markResolved: 'Marcar Resuelto',
  markOpen: 'Marcar Abierto',
  clear: 'Limpiar',
  startDate: 'Fecha de Inicio',
  endDate: 'Fecha de Fin',
  errorType: 'Tipo de Error',
  status: 'Estado',
  searchPlaceholder: 'Buscar mensaje o usuario',
  type: 'Tipo',
  message: 'Mensaje',
  user: 'Usuario',
  timestamp: 'Fecha y Hora',
  anonymous: 'Anónimo',
  resolved: 'Resuelto',
  open: 'Abierto',
  errorDetails: 'Detalles del Error',
  errorName: 'Nombre del Error',
  url: 'URL',
  route: 'Ruta',
  unknown: 'Desconocido',
  userAgent: 'Agente de Usuario',
  resolvedAt: 'Resuelto el',
  context: 'Contexto',
  stackTrace: 'Traza de Pila',
  noErrorLogs: 'No se encontraron registros de errores',
  cleanupOldErrors: 'Limpiar Errores Antiguos',
  cleanupMessage: 'Esto eliminará permanentemente los registros de errores con más de {days} días de antigüedad.',
  daysToKeep: 'Días a conservar',
  cancel: 'Cancelar',
  delete: 'Eliminar',
  javascript: 'JavaScript',
  vue: 'Vue',
  promise: 'Promesa',
  manual: 'Manual',
  warning: 'Advertencia',
  info: 'Información',
  failedToLoadLogs: 'Error al cargar los registros de errores',
  errorMarkedAs: 'Error marcado como {status}',
  failedToUpdateStatus: 'Error al actualizar el estado del error',
  noErrorsSelected: 'No hay errores seleccionados',
  errorsMarkedAs: '{count} errores marcados como {status}',
  failedBulkUpdate: 'Error al actualizar los errores en lote',
  deletedOldLogs: 'Se eliminaron {count} registros de errores antiguos',
  failedCleanup: 'Error al limpiar los registros antiguos'
}
